<div [class]="containerClass()">
  <span class="block text-sm/6 font-medium font-header my-auto">{{ label() }}</span>

  <ng-content></ng-content>
</div>
